import { render, staticRenderFns } from "./wrDebtPersonHome.vue?vue&type=template&id=a0115a4a&"
import script from "./wrDebtPersonHome.vue?vue&type=script&lang=js&"
export * from "./wrDebtPersonHome.vue?vue&type=script&lang=js&"
import style0 from "./wrDebtPersonHome.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports